<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'sidebar',
})
</script>
<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2025-02-28 16:17:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-14 18:14:45
 * @FilePath: /qd-c4-yunjing-web/src/layouts/components/sidebar/sidebar-collapse.vue
 * @Description:
-->
<template>
  <section class="sidebar-collapse">
    <el-menu
      :default-active="activeMenu"
      :unique-opened="true"
      :collapse-transition="true"
      class="el-menu-vertical"
      @open="handleOpen"
      @close="handleClose"
    >
      <sidebar-collapse-item
        v-for="raw in permissionRoutes"
        :key="raw.path"
        :item="raw"
        :base-path="raw.path"
        @blank-click="handleBlankClick"
      />
    </el-menu>
  </section>
</template>
<script lang="ts" setup name="sidebar">
  import {
    computed, onMounted, ref, watch,
  } from 'vue';
  import SidebarCollapseItem from './sidebar-collapse-item.vue';

  const emit = defineEmits(['blank-click']);

  const props = defineProps({
    permissionRoutes: {
      type: Array<any>,
      default: [],
    },
    activeMenu: {
      type: String,
      default: '',
    },
  });

  const handleOpen = (key: string, keyPath: string[]) => {
    console.log(key, keyPath);
  };
  const handleClose = (key: string, keyPath: string[]) => {
    console.log(key, keyPath);
  };
  const handleBlankClick = (info:TypeObject) => {
    emit('blank-click', info);
  };
  onMounted(() => {
    console.log('二级导航', props.permissionRoutes);
  });
</script>

<style lang="scss" scoped>
  .el-menu-vertical{
  width: calc(100% - 4px);
  background: transparent;
  border: 0;
}

.sidebar-collapse{
  box-sizing: border-box;
  width: 100%;
  height: calc(100vh - var(--maia-nav-header-height));
  padding: 8px 4px var(--maia-base-space) 4px;
  // background: linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)),
  //   linear-gradient(88.24deg, rgba(231, 239, 248, 0.4) 1.58%, rgba(231, 239, 248, 0) 91.32%);
  background: linear-gradient(90deg, rgba(237, 246, 255, 0) 0%, rgba(237, 246, 255, 0.6) 10%),
    linear-gradient(262.34deg, rgba(211, 225, 239, 0) 7.75%, rgba(212, 225, 239, 0.2) 90.1%);
  backdrop-filter: blur(4px);
  transition: all 0.3s linear;
}

:deep(.ma-menu--inline){
  background-color: transparent;
}

:deep(.ma-menu-item){
  // height: 36px;
  margin-bottom: 2px;
  color: #434C59;
  font-weight: 600;
  font-size: 14px;

  &:hover{
    background-color: rgba($color: #FFF, $alpha: 0.5);
    border-radius: 4px;
    box-shadow: 2px 6px 8px 2px rgba($color: #007BF5, $alpha: 0.25);
  }
}

:deep(.ma-sub-menu__title){
  margin-bottom: 2px;
  color: #434C59;
  font-weight: 600;
  font-size: 14px;

  &:hover{
    background-color: rgba($color: #FFF, $alpha: 0.5);
    border-radius: 4px;
    box-shadow: 2px 6px 8px 2px rgba($color: #007BF5, $alpha: 0.3);
  }
}

:deep(.ma-sub-menu){
  .ma-menu-item{
    span{
      margin-left: -8px;
    }
  }
}

:deep(.is-active:not(.is-opened)){
  color: #409EFF;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 8px 0 rgba(30, 49, 72, 0.15);
  transition: background 0.3s linear;

  .ma-sub-menu__title{
    color: #409EFF;
  }
}

</style>
